export default {
  title: 'Registrieren / Anmelden, um deine Bestellhistorie anzuzeigen',
  subtitle: 'Melde dich an, um dein Konto und deine Bestellungen zu verwalten',
  benefits: {
    earn_points: {
      title: 'Sammle Punkte bei jeder Bestellung',
      description: 'Sammle Punkte und schalte exklusive Belohnungen frei',
    },
    get_deals: {
      title: 'Erhalte exklusive Angebote',
      description: 'Nutze deine Punkte, um kostenlose Artikel zu bekommen',
    },
    redeem_points: {
      title: 'Löse Punkte für Rabatte ein',
      description: 'Erhalte Zugang zu exklusiven Mitglieder-Aktionen',
    },
  },
};
